import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Dialog from '../dialog.jsx';
import DestinationSections from '../destination_sections.jsx';
import classnames from 'classnames';
import { capitalize } from 'utils';

function ValidationError({ error, id }) {
    return (
        <div
            aria-live="polite"
            id={id}
            className={error != null ? 'validation-error' : undefined}
        >
            {error}
        </div>
    );
}
ValidationError.propTypes = {
    error: PropTypes.string,
    id: PropTypes.string,
};

export default class LinkDisplay extends PureComponent {
    static propTypes = {
        onClose: PropTypes.func,
        onSave: PropTypes.func,
        sections: PropTypes.any,
        terms: PropTypes.any,
        validationErrors: PropTypes.shape({
            value: PropTypes.any,
            requestChange: PropTypes.func,
        }),
        selectedSections: PropTypes.array,
        title: PropTypes.string,
        url: PropTypes.string,
        embed: PropTypes.string,
        description: PropTypes.string,
        setContent: PropTypes.func,
    };

    constructor({ title, url, embed, description, setContent }) {
        super();
        Object.keys({
            title,
            url,
            embed,
            description,
        }).forEach(key => {
            this[`set${capitalize(key)}`] = ({ currentTarget: { value } }) =>
                setContent({ [key]: value });
        });
    }

    setSelectedSections = selectedSections => {
        this.props.setContent({ selectedSections });
    };

    render() {
        const {
            sections,
            terms,
            validationErrors,
            selectedSections,
            title,
            url,
            embed,
            description,
        } = this.props;

        const buttons = [];
        buttons.push({
            label: 'Cancel',
            dismiss: true,
        });
        buttons.push({
            label: 'Add Link',
            onClick: this.props.onSave,
            primary: true,
        });

        return (
            <Dialog
                buttons={buttons}
                closeButton
                onClose={this.props.onClose}
                title="Add External Link"
            >
                <div id="formLegend">
                    <p>All fields are required unless otherwise noted.</p>
                </div>
                <div>
                    <label
                        className={classnames({
                            'validation-error': validationErrors.title,
                        })}
                        htmlFor="_engage64"
                    >
                        Title
                    </label>
                    <input
                        value={title}
                        onChange={this.setTitle}
                        onInvalid={e =>
                            e.target.setCustomValidity('Title is required')
                        }
                        onInput={e => e.target.setCustomValidity('')}
                        required="required"
                        type="text"
                        id="_engage64"
                        aria-required
                        aria-describedby="error-title"
                    />
                    <ValidationError
                        error={validationErrors.title}
                        id="error-title"
                    />
                </div>
                <div>
                    <label
                        className={classnames({
                            'validation-error': validationErrors.url,
                        })}
                        htmlFor="_engage65"
                    >
                        URL
                    </label>
                    <input
                        value={url}
                        onChange={this.setUrl}
                        onInvalid={e =>
                            e.target.setCustomValidity('URL is required')
                        }
                        onInput={e => e.target.setCustomValidity('')}
                        required="required"
                        type="text"
                        id="_engage65"
                        aria-required
                        aria-describedby="error-url"
                    />
                    <ValidationError
                        error={validationErrors.url}
                        id="error-url"
                    />
                </div>
                <div>
                    <label htmlFor="_engage66">
                        Embed Code
                        <span className="secondary">(Optional)</span>
                    </label>
                    <textarea
                        value={embed}
                        onChange={this.setEmbed}
                        name="embed"
                        aria-describedby="aria-embed-instructions"
                        id="_engage66"
                    />
                    <aside id="aria-embed-instructions">
                        <p className="secondary">
                            URLs must begin with 'https:'. URLs that begin with
                            'http:' or have no protocol specified will be
                            automatically updated.
                        </p>
                    </aside>
                </div>
                <div>
                    <label htmlFor="linkDescription">
                        Description
                        <span className="secondary">(Optional)</span>
                    </label>
                    <textarea
                        value={description}
                        onChange={this.setDescription}
                        name="description"
                        id="linkDescription"
                    />
                </div>

                <ValidationError
                    error={validationErrors.sections}
                    id="error-sections"
                />
                <DestinationSections
                    sections={sections}
                    terms={terms}
                    selectedSections={selectedSections}
                    onChange={this.setSelectedSections}
                    error={validationErrors.sections}
                />
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/link_dialog/display.jsx